import Dexie from "dexie";
import lodashGet from "lodash/get";

export { _getDB as getDB };
export { _addDBItem as addDBItem };
export { _getAllDBItems as getAllDBItems };
export { _getDBItem as getDBItem };
export { _deleteAllDBItems as deleteAllDBItems };

const _getDB = (params) => {
  const DB = new Dexie(params.dbName);
  let options = {};
  options[params.storeName] = params.indexes;
  DB.version(1).stores(options);
  options = null;
  return DB;
};

const _addDBItem = async (params) => {
  if (!params.db) {
    console.error("Error in _addDBItem for browserDb.js. No db set.");
    return null;
  }
  if (!params.store) {
    console.error("Error in _getAllDBItemd for browserDb.js. No store set.");
    return null;
  }
  if (!params.payload) {
    console.error("Error in _getAllDBItemd for browserDb.js. No payload set.");
    return null;
  }
  return await params.db
    .transaction("rw", params.db[params.store], async () => {
      const RESULT = await params.db[params.store].put(params.payload);
      return RESULT;
    })
    .catch((e) => {
      console.error("Error in addDBItems for browserDb.js", e.stack || e);
      return null;
    });
};

const _getAllDBItems = async (params) => {
  if (!params.db) {
    console.error("Error in _getAllDBItemd for browserDb.js. No db set.");
    return null;
  }
  if (!params.store) {
    console.error("Error in _getAllDBItemd for browserDb.js. No store set.");
    return null;
  }
  return await params.db
    .transaction("rw", params.db[params.store], async () => {
      const ITEMS = await params.db[params.store].toArray();
      return ITEMS;
    })
    .catch((e) => {
      console.error("Error in getAllDBItems for browserDb.js", e.stack || e);
      return null;
    });
};

const _getDBItem = async (params) => {
  if (!params.db) {
    console.error("Error in _getDBItem for browserDb.js. No db set.");
    return null;
  }
  if (!params.store) {
    console.error("Error in _getAllDBItemd for browserDb.js. No store set.");
    return null;
  }
  if (!params.payload) {
    console.error("Error in _getAllDBItemd for browserDb.js. No payload set.");
    return null;
  }
  return await params.db
    .transaction("rw", params.db[params.store], async () => {
      if (lodashGet(params, "db[params.store]") && params.payload) {
        return await params.db[params.store].get(params.payload);
      }
      return null;
    })
    .catch((e) => {
      console.error("Error in _getDBItem for browserDb.js", e.stack || e);
      return null;
    });
};

/// TODO: _addDBItems (bulk put)

/// TODO: _deleteDBItem

/// TODO: _deleteDBItems (bulk delete)

/// TODO: _deleteAllDBItems
const _deleteAllDBItems = async (params) => {
  if (!params.db) {
    console.error("Error in deleteAllDBItems for browserDb.js. No db set.");
    return null;
  }
  if (!params.store) {
    console.error("Error in deleteAllDBItems for browserDb.js. No store set.");
    return null;
  }
  return await params.db
    .transaction("rw", params.db[params.store], async () => {
      const ITEMS = await params.db[params.store].clear();
      return ITEMS;
    })
    .catch((e) => {
      console.error("Error in deleteAllDBItems for browserDb.js", e.stack || e);
      return null;
    });
};
